import React from 'react';
import PropTypes from 'prop-types';

export const Swap = ({ width, height, ...props }) => (
  <svg
    data-icon='swap'
    xmlns='http://www.w3.org/2000/svg'
    width={ width }
    height={ height }
    fill='none'
    viewBox='0 0 24 24'
    { ...props }
  >
    <path
      fill='currentColor'
      d='M8 13V5.825L5.425 8.4 4 7l5-5 5 5-1.425 1.4L10 5.825V13H8Zm7 9-5-5 1.425-1.4L14 18.175V11h2v7.175l2.575-2.575L20 17l-5 5Z'
    />
  </svg>
);

Swap.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

Swap.defaultProps = {
  width: 24,
  height: 24,
};
